<template>
  <nav id="navigation-header"
    :class="this.previousUser ? 'navbar navbar-inverse navbar-fixed-top alert-header' : 'navbar navbar-inverse navbar-fixed-top'">
    <div class="nav-wrap">
      <div class="mobile-only-brand pull-left">
        <generic-button iconClass="ti-align-left" class="toggle-left-nav-btn pull-left visible-md visible-xs visible-sm"
          @clicked="toggleSideMenu" />
        <div class="nav-header pull-left">
          <div class="nav-header-container">
            <a class="action-button" @click="navigate">
              <span class="brand-text">
                <img alt="brand" src="static/logo.png" width="200px">
                <span v-if="newFeedCount > 0 && canSeeBadge"
                  class="top-nav-icon-badge new-message-badge">{{ newFeedCount }}</span>
              </span>
            </a>
          </div>
        </div>
        <div class="user-information">
          <div class="row">
            <span class="title">{{ this.$t('app.navigation.user_name') }}</span>
            <span class="data">{{ this.loggedInUser.name }}</span>
            <span class="title">{{ this.$t('app.navigation.user_role') }}</span>
            <span>{{ $t(`app.roles.${this.loggedInUser.role}`) }}</span>
          </div>
        </div>
      </div>
      <div id="mobile_only_nav" class="mobile-only-nav pull-right">
        <ul class="nav navbar-right top-nav pull-right">
          <li v-if="!this.previousUser && loggedInUser.role !== 'super_admin'" class="dropdown alert-drp">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i @click="showNotifications" class="ti-bell top-nav-icon"></i>
              <span v-if="notificationsCount > 0" class="top-nav-icon-badge">{{ notificationsCount }}</span>
            </a>
          </li>
          <li class="dropdown alert-drp">
            <a class="dropdown-toggle">
              <i class=""></i>
              <span @click="logOut" :class="this.previousUser ? 'alert-login' : ''">{{ this.previousUser
                ? $t('app.changeBack') : $t('app.logout') }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import store from '@/store/store';
import { mapActions, mapGetters } from 'vuex';
import GenericButton from '@/components/shared/buttons/GenericButton';
import NotificationList from '@/components/shared/notifications/NotificationList';

export default {
  name: 'NavigationHeader',
  components: {
    'generic-button': GenericButton,
    'notification-list': NotificationList,
  },
  props: {
    notificationCount: {
      type: Number,
      required: false,
    },
    feedCount: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      selectedLang: 'en',
      selectedList: ['en', 'hu'],
      newFeedCount: 0,
      currentPageIndex: 1,
      showDropDown: false,
      notifications: [],
      notificationsCount: 0,
    };
  },
  created() {
    if (this.loggedInUser.role !== 'super_admin') {
      this.fetchNotifications({ id: this.loggedInUser.id, pageIndex: this.currentPageIndex }).then((response) => {
        this.notificationsCount = response.total_count;
      });
    }

    this.fetchUser({ id: this.loggedInUser.id }).then((response) => {
      this.newFeedCount = response.new_feed_count;
    });
  },
  methods: {
    ...mapActions({
      logoutUser: 'users/logoutUser',
      fetchNotifications: 'users/fetchNotifications',
      updateNotifications: 'users/updateNotifications',
      fetchUser: 'users/fetchUser',
      createUserAction: 'users/createUserAction',
      changeUser: 'users/changeUser',
      fetchCommonData: 'partners/fetchCommonData',
    }),
    toggleSideMenu() {
      this.$eventBus.toggleSideMenu();
    },
    logOut() {
      if (this.previousUser) {
        store.commit('storeLoggedInUser', this.previousUser);
        store.commit('removePreviousUser');
        this.fetchCommonData(this.loggedInUser.id).then(() => {
          if (this.$route.name === 'DashboardScreen') {
            this.$router.push({ name: 'PartnersScreen' });
          } else {
            this.$router.push({ name: 'DashboardScreen' });
          }
        });
      } else {
        this.logoutUser()
          .then((response) => {
            this.$eventBus.hideLoading({});
            this.navigateToLogin();
          })
          .catch(() => {
            this.navigateToLogin();
          });
      }
    },
    navigateToLogin() {
      this.$router.push({ path: '/login' });
    },
    showNotifications() {
      this.fetchNotifications({ id: this.loggedInUser.id, pageIndex: this.currentPageIndex }).then((response) => {
        this.notifications = response.notifications;
        this.$eventBus.showModal({
          bind: {
            is: NotificationList,
            totalPages: response.total_pages,
          },
          on: {
            modalCanceled: this.modalCanceled,
          },
        });
      });
    },
    modalCanceled() {
      this.updateNotifications({ id: this.loggedInUser.id }).then(() => {
        this.notificationsCount = 0;
      });
    },
    navigateBack() {
      this.$router.go(-1);
    },
    navigate() {
      if (!this.previousUser && this.loggedInUser.role !== 'super_admin') {
        this.newFeedCount = 0;
        this.$router.push({ path: '/feeds' });
        this.createUserAction({ id: this.loggedInUser.id, params: { action_type: 'check_feeds' } });
      }
    },
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
      previousUser: 'previousUser',
      commonData: 'partners/commonData',
      selectedLanguage: 'selectedLanguage',
    }),
    canSeeBadge() {
      return this.loggedInUser.role !== 'super_admin'
    },
    navLanguage() {
      if (this.selectedLanguage === 'hu_HU') {
        return 'hu';
      }
      return 'en';
    },
  },
  watch: {
    notificationCount(newValue) {
      this.notificationsCount = newValue;
    },
    feedCount(newValue) {
      this.newFeedCount = newValue;
    },
  },
};
</script>

<style lang="scss" scoped>
#navigation-header {
  max-height: 29px !important;

  .toggle-left-nav-btn {
    line-height: 80px !important;
    width: 50px;
    text-align: center;
    background: white;
    z-index: 4;

    @media(max-width: 1024px) {
      line-height: 66px !important;
    }

  }

  .mobile-only-brand {
    width: 100%;
    display: flex;
    min-height: 85px;
  }

  @media (max-width: 1200px) {
    .mobile-only-brand {
      padding-right: 65px;
    }
  }

  @media (max-width: 1024px) {
    .mobile-only-brand {
      min-height: 60px;
    }
  }

  .navbar-right {
    position: absolute;
    top: 0;
    right: 0;
  }

  .menu {
    position: absolute;
    top: 100%;
    right: 0%;
    z-index: 1000;
    float: left;
    margin: 2px 0 0;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background-color: #fff;
    border-radius: 2px;
    border: none;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.175);
  }

  .list {
    margin: 5px;

    a {
      display: flex;
      align-items: center;
      padding: 3px 20px;
      clear: both;
      font-weight: 400;
      line-height: 1.42857143;
      color: #333;
      white-space: nowrap;

      i {
        color: #000000;
        font-size: 18px;
        margin-right: 10px;
      }
    }
  }

  .divider {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #e5e5e5;
  }

  .brand-img {
    &.small {
      width: 25px;
      height: 25px;
    }
  }

  .dropdown-toggle {
    cursor: pointer;
  }

}

.navigation {
  display: none;

  @media (min-width: 600px) {
    display: flex;
  }

  float: left;
  align-items: center;
  height: 85px;
}

.navigation-button {
  cursor: pointer;
  padding: 20px;
}

.user-information {
  display: flex;
  align-items: center;
  float: left;
  align-items: center;
  justify-content: center;
  width: 60%;
}

.title {
  font-weight: bold;
}

.data {
  margin-right: 15px;
}

.nav-header {
  width: 250px !important;
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 0 !important;

  .nav-header-container {
    @media(max-width: 1024px) {
      margin-left: 45px;
    }
  }
}

@media (max-width: 1400px) {
  .nav-header {
    width: 15% !important;
    overflow: visible !important;
  }
}


.new-message-badge {
  background: var(--main-color);
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  height: 20px;
  font-weight: 500;
  line-height: 19px;
  position: absolute;
  right: 0;
  text-align: center;
  top: 22px;
  width: 20px;
  position: absolute;
  top: 5%;
  left: 24%;
}

@media (max-width: 1400px) {
  .new-message-badge {
    top: 10%;
  }
}

.action-button {
  cursor: pointer;

  .brand-text {
    img {
      padding-left: 15px;
      max-height: 60px;
      width: auto;
    }
  }
}

.alert-login {
  color: var(--main-color);
  font-weight: bold;
}

.alert-header {
  border-top: 5px solid var(--main-color) !important;
}</style>



// WEBPACK FOOTER //
// src/components/shared/navigations/NavigationHeader.vue